import axios from 'axios';

// Cache for token
let tokenCache = null;
let tokenExpiry = null;

// Helper to check if token is expiring soon (2 min buffer)
function isTokenExpiring() {
  if (!tokenExpiry) return true;
  return new Date(tokenExpiry) < new Date(Date.now() + 2 * 60 * 1000);
}

// Function to get API token using axios (avoiding interceptors)
async function getApiToken() {
  try {
    // Browser will set Origin header automatically, don't set manually
    // const origin = window.location.origin;
    
    const response = await axios.post('/bookings/api-token', {}, {
      headers: { 
        'Skip-Auth-Interceptor': 'true'
        // Origin is automatically set by browser
      }
    });
    
    if (response.data && response.data.token) {
      tokenCache = response.data.token;
      tokenExpiry = response.data.expires_at;
      return tokenCache;
    }
    return null;
  } catch (error) {
    // console.error('Error getting API token for fetch:', error);
    return null;
  }
}

/**
 * Enhanced fetch function that automatically adds the API token
 * Use this instead of the native fetch() for API calls
 * 
 * @param {string} url - The URL to fetch
 * @param {Object} options - Standard fetch options
 * @returns {Promise} - The fetch promise
 */
export async function fetchWithToken(url, options = {}) {
  // Check if we need a new token
  if (!tokenCache || isTokenExpiring()) {
    await getApiToken();
  }
  
  // Ensure we have headers object
  const headers = options.headers || {};
  
  // Don't manually set Origin - browser will set it automatically
  // const origin = window.location.origin;
  // headers['Origin'] = origin;
  
  // Add API token if available
  if (tokenCache) {
    headers['X-API-Token'] = tokenCache;
  }
  
  // Add auth token if available (for authenticated endpoints)
  const authToken = localStorage.getItem('token');
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }
  
  // Ensure Content-Type is set for POST requests
  if (options.method === 'POST' && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  
  // Return fetch with enhanced options
  return fetch(url, {
    ...options,
    headers
  });
}

export default fetchWithToken; 